<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <div class="z-title z-title--small spacer-bottom-s">
            Trocar forma de pagamento
          </div>

          <p class="z-text">
            Escolha uma das opções abaixo como forma padrão de pagamento das mensalidades.
          </p>
        </div>

        <div class="bsd-section">
          <p class="z-caption payment-method-label">
            Forma de pagamento atual
          </p>

          <div class="z-card payment-card" v-if="currentPaymentMethod === 'boleto'">
            <z-icon
              size="large"
              color="primary"
              :icon="['fal', 'barcode-alt']"
            />

            <p class="z-text z-text--bold payment-text">
              Boleto
            </p>
          </div>

          <div class="z-card payment-card" v-else-if="currentPaymentMethod === 'pix'">
            <z-icon
              size="large"
              color="primary"
              :icon="['fal', 'qrcode']"
            />

            <p class="z-text z-text--bold payment-text">
              Pix
            </p>
          </div>

          <div class="z-card" v-else>
            <card-preview :card="currentCreditCard" />
          </div>
        </div>

        <alert-box ref="alertBox" class="spacer-l" />

        <div class="payment-methods-wrapper">
          <div class="z-title z-title--small spacer-bottom-l" v-if="currentPaymentMethod === 'boleto'">
            Adicionar um cartão como forma de pagamento
          </div>
          <div class="z-title z-title--small spacer-bottom-l" v-else>
            Adicionar uma nova forma de pagamento
          </div>

          <div
            class="z-card z-card--with-hover payment-card payment-card--with-hover"
            @click="goToCreditPaymentMethod"
            v-if="showPaymentMethod('credit_card')"
          >
            <z-icon
              size="large"
              color="primary"
              :icon="['fal', 'credit-card-blank']"
            />

            <p class="z-text z-text--bold payment-text">
              Cartão de crédito
            </p>
          </div>

          <div
            class="z-card z-card--with-hover payment-card payment-card--with-hover"
            @click="selectPaymentMethod('Pix')"
            v-if="currentPaymentMethod !== 'pix' && showPaymentMethod('pix')"
          >
            <z-icon
              size="large"
              color="primary"
              :icon="['fal', 'qrcode']"
            />

            <p class="z-text z-text--bold payment-text">
              Pix
            </p>
          </div>

          <div
            class="z-card z-card--with-hover payment-card payment-card--with-hover"
            @click="selectPaymentMethod('Boleto')"
            v-if="currentPaymentMethod !== 'boleto' && showPaymentMethod('boleto')"
          >
            <z-icon
              size="large"
              color="primary"
              :icon="['fal', 'barcode-alt']"
            />

            <p class="z-text z-text--bold payment-text">
              Boleto
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.payment-method-label {
  margin-bottom: var(--space-medium);
}

.payment-card {
  align-items: center;
  display: flex;
  margin-bottom: var(--space-large);
}

.payment-card--with-hover {
  cursor: pointer;
}

.payment-text {
  margin-left: var(--space-medium);
}

.payment-methods-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: var(--space-giant);
}
</style>

<script>
import AlertBox from 'components/zilla/alert-box';
import Breadcrumb from 'components/breadcrumb';
import CardPreview from 'components/card-preview';
import RecurrentPaymentMethodService from 'services/RecurrentPaymentMethodService';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    AlertBox,
    Breadcrumb,
    CardPreview,
  },
  computed: {
    ...mapState([
      'currentBilling',
    ]),
    ...mapGetters([
      'permittedPaymentMethods',
    ]),
    currentPaymentMethod() {
      return this.currentBilling.recurrent_payment_method;
    },
    currentCreditCard() {
      return this.currentBilling.student_card;
    },
  },
  methods: {
    selectPaymentMethod(paymentMethod) {
      this.$pageLoader.wrap(this.updatePaymentMethod(paymentMethod), 'Salvando forma de pagamento.');
      this.$tracker.logEvent(`[change payment method] Clicked "${paymentMethod}"`);
    },
    updatePaymentMethod(paymentMethod) {
      const methodName = `enable${paymentMethod}`;

      return RecurrentPaymentMethodService[methodName](this.currentBilling.id)
        .then(() => {
          this.$router.push({ name: 'cpm-success' });
        })
        .catch(() => {
          this.$refs.alertBox.show(
            'danger', 'Erro inesperado',
            'Houve um problema ao alterar a forma de pagamento. Tente novamente ou entre em contato com o Quero Pago.',
          );
        });
    },
    goToCreditPaymentMethod() {
      this.$tracker.logEvent('[change payment method] Clicked "Cartão de crédito"');
      this.$router.push({ name: 'cpm-credit-card-selection' });
    },
    showPaymentMethod(paymentMethod) {
      return this.permittedPaymentMethods.includes(paymentMethod);
    },
  },
  mounted() {
    this.$tracker.logEvent('[change payment method] Viewed Change Payment Method Page');
  },
};
</script>
